import { cn } from '@/lib/utils';

type BrandMarkSize = 'sm' | 'md' | 'lg' | 'xl';

type BrandMarkProps = {
  size?: BrandMarkSize;
  className?: string;
};

const markSizes: Record<BrandMarkSize, string> = {
  sm: 'h-9 w-9 rounded-lg text-sm',
  md: 'h-12 w-12 rounded-xl text-base',
  lg: 'h-16 w-16 rounded-2xl text-xl',
  xl: 'h-24 w-24 rounded-3xl text-3xl',
};

export function BrandMark({ size = 'sm', className }: BrandMarkProps) {
  return (
    <div
      className={cn('flex shrink-0 items-center justify-center overflow-hidden shadow-sm', markSizes[size], className)}
    >
      <img src="/android-chrome-512x512.png" alt="Vira Tempo Studio" className="h-full w-full object-cover" />
    </div>
  );
}

type BrandLockupProps = {
  className?: string;
  markClassName?: string;
  textClassName?: string;
  markSize?: BrandMarkSize;
};

export function BrandLockup({ className, markClassName, textClassName, markSize = 'sm' }: BrandLockupProps) {
  return (
    <div className={cn('flex min-w-0 items-center gap-3', className)}>
      <BrandMark size={markSize} className={markClassName} />
      <span className={cn('truncate font-bold', textClassName)}>Vira Tempo Studio</span>
    </div>
  );
}
